import { gql } from "@apollo/client";

const GET_DISTRIBUTION_CENTER = gql`
  query GetDistributionCenter($params: GetDistributionCenterParams!) {
    distributionCenters(params: $params) {
      count
      items {
        dcId
        dcCode
        dcName
        purchaserId
        purchaserName
      }
    }
  }
`;

export default GET_DISTRIBUTION_CENTER;
